import styles from "./styles/Rect.module.css";

function Rect({ specialMargin = false }) {
  return (
    <div
      className={styles.rect}
      style={specialMargin ? { margin: "30px auto " } : {}}
    ></div>
  );
}

export default Rect;
